import api from "api";
const path = `api/auth/reset/email`;

export default {
    request: email => api.post({path, params:{email}})
}
